





















import {Vue, Component} from 'vue-property-decorator';
import {addClass, removeClass} from '@/utils/classUtils';
import {popupResize} from '@/utils/ncp';

@Component
export default class GroupList extends Vue {
  private groupNames: any = [];
  private async mounted() {
    addClass(document.body, 'popup_small');
    if (this.$route.query) {
      let request: any = {
        pathParams: {
          memberNo: this.$route.query.memberNo
        }
      };
      let {data} = await this.$api.getMembersMemberNo(request);
      this.groupNames = data.groupNames;
    }
    this.$nextTick(() => {
      popupResize();
    });
  }

  private beforeDestroy() {
    removeClass(document.body, 'popup_small');
  }
}
